import React from "react";
import themeConfig from "../../config/themeConfig";
import "../../styles/OwnerAdmin.css";
import Header from "../Header";

const Profile = ({ currentTheme, setCurrentTheme }) => {
  const handleThemeChange = (event) => {
    setCurrentTheme(event.target.value);
  };

  return (
    <div className="bg-gray-50">
      <Header title="Welcome to the Profile Page" />
      {/* <div className="theme-selector min-h-screen">
        <label htmlFor="theme-dropdown">Colour Scheme:</label>
        <select id="theme-dropdown" value={currentTheme} onChange={handleThemeChange}>
          {Object.keys(themeConfig.themes).map((themeKey) => (
            <option key={themeKey} value={themeKey}>
              {themeKey.charAt(0).toUpperCase() + themeKey.slice(1)}
            </option>
          ))}
        </select>
      </div> */}

      <div className="bg-white shadow-lg rounded-lg p-6 max-w-3xl mx-auto mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-6">
          Theme Preferences
        </h2>

        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center">
            <label
              htmlFor="theme-dropdown"
              className="block text-sm font-medium text-gray-700 sm:w-1/3 mb-2 sm:mb-0"
            >
              Color Scheme:
            </label>
            <div className="sm:w-2/3">
              <select
                id="theme-dropdown"
                value={currentTheme}
                onChange={handleThemeChange}
                className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-900 focus:outline-gray-200 focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md shadow-sm"
              >
                {Object.keys(themeConfig.themes).map((themeKey) => (
                  <option key={themeKey} value={themeKey}>
                    {themeKey.charAt(0).toUpperCase() + themeKey.slice(1)}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <div className="flex items-center">
              <div
                className="w-12 h-12 rounded-full mr-4"
                style={{
                  backgroundColor:
                    themeConfig.themes[currentTheme].leftNavBackgroundColor,
                }}
              ></div>
              <div>
                <p className="text-sm font-medium text-gray-900">
                  Primary Color
                </p>
                <p className="text-sm text-gray-500">
                  {themeConfig.themes[currentTheme].leftNavBackgroundColor}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
